import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, SubscriptionPayment, OptionPayment, User, BreadcrumbItem } from '../../../entities/index';
import { SubscriptionService } from '../../../services/subscription.service';
import { SubscriptionPaymentService } from '../../../services/subscription-payment.service';
import { OptionPaymentService } from '../../../services/option-payment.service';
import { UserService } from '../../../services/user.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-subscription-detail',
  templateUrl: './subscription-detail.html'
})
export class SubscriptionDetailComponent implements OnInit {
  subscriptionId: number;
  subscription: Subscription = new Subscription();
  user: User = new User();
  payments: SubscriptionPayment[] = [];
  subscriptionOptionPayments: OptionPayment[] = [];
  accountOptionPayments: OptionPayment[] = [];
  listFileUrl: { [key: number]: any } = [];
  fileUrlLoading: { [key: number]: boolean } = [];

  pageTitle = 'Subscription Detail';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('Subscription Detail', 'usd')
  ];

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected subscriptionService: SubscriptionService,
    protected subscriptionPaymentService: SubscriptionPaymentService,
    protected optionPaymentService: OptionPaymentService,
    protected userService: UserService,
    private sanitizer: DomSanitizer) {
    this.subscriptionId = Number(route.snapshot.params.id);
    this.pageTitle += ' #' + this.subscriptionId;
    this.breadcrumbs[0].title = this.pageTitle;
  }

  @Log()
  ngOnInit() {
    this._loadData();
  }

  protected _loadData() {
    this.subscriptionService
      .get(this.subscriptionId)
      .subscribe(subscription => {
        this.subscription.card_expiry_string = null
        this.subscription = subscription;
        this._loadUser(subscription.user_id);
        this._loadPayments(this.subscription);
        this._loadOptionPayments(this.subscription);
        this._loadAccountOptionPayments(subscription.user_id);
        this._setCardExpiry(this.subscription.card_expiry)
      });
  }

  _setCardExpiry(cardExpiryDate) {
    if (!cardExpiryDate) {
      return
    }
    const DateExpiryFormated = new Date(cardExpiryDate)
    const month = DateExpiryFormated.getUTCMonth() + 1;
    const year = DateExpiryFormated.getUTCFullYear();
    const start = new Date(Date.now())
    if (start < DateExpiryFormated) {
      return
    }
    this.subscription.card_expiry_string = month + '/ ' + year
  }
  protected _loadUser(userId: number) {
    this.userService.get(userId).subscribe(user => this.user = user);
  }

  protected _loadPayments(subscription: Subscription) {
    this.subscriptionPaymentService.findAllBySubscription(subscription).subscribe(payments => this.payments = payments);
  }

  protected _loadOptionPayments(subscription: Subscription) {
    this.optionPaymentService.getSubscriptionOptionPayments(subscription.id).subscribe(result => this.subscriptionOptionPayments = result);
  }

  protected _loadAccountOptionPayments(user_id: number) {
    this.optionPaymentService.getAccountOptionPayments(user_id).subscribe(payments => this.accountOptionPayments = payments);
  }

  @Log('blue')
  downloadInvoice(invoiceId: number, paymentType: string) {
    this.fileUrlLoading[invoiceId] = true;

    let invoiceService;
    if (paymentType === '/subscriptionpayment/') {
      invoiceService = this.subscriptionService.subsImportFile(invoiceId);
    } else {
      invoiceService = this.subscriptionService.optionImportFile(invoiceId);
    }

    invoiceService
      .finally(() => this.fileUrlLoading[invoiceId] = false)
      .subscribe(
        (response: string) => {
          this.listFileUrl[invoiceId] = this.sanitizer.bypassSecurityTrustUrl(response);
        },
        error => console.log(error)
      );
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/subscription/subscription-detail.component.ts